import { ActionIcon, Code, CopyButton, Group, Text, Tooltip } from "@mantine/core";
import { MdContentCopy, MdDone } from "react-icons/md";

export interface SttRequestIdsProps {
    ids?: string[];
}

/** Admin-only: the speech-to-text request ids of a dictated question, each copyable. */
export const SttRequestIds = ({ ids }: SttRequestIdsProps) => {
    if (!ids || ids.length === 0) {
        return null;
    }

    return (
        <Group justify="flex-end" gap="xs" wrap="wrap">
            <Text size="xs" c="dimmed">
                {ids.length === 1 ? "STT ID:" : "STT IDs:"}
            </Text>
            {ids.map(id => (
                <Group key={id} gap={2} wrap="nowrap">
                    <Code>{id}</Code>
                    <CopyButton value={id} timeout={2000}>
                        {({ copied, copy }) => (
                            <Tooltip label={copied ? "Copied" : "Copy STT ID"} withArrow>
                                <ActionIcon variant="transparent" color="blue.9" size="sm" onClick={copy} aria-label="Copy STT ID">
                                    {copied ? <MdDone size={16} /> : <MdContentCopy size={14} />}
                                </ActionIcon>
                            </Tooltip>
                        )}
                    </CopyButton>
                </Group>
            ))}
        </Group>
    );
};
